import React, { useState, useEffect, useContext } from "react";
import { BreadCrum } from "../../common";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { CommanSearchBox } from "../../common/commanSearchBox";
import CommonTable from "../../common/CommonTable";
import { releaseDocumentsColumns } from "./ReleaseDocumentsUtils";
import { useDispatch, useSelector } from "react-redux";
import { getReleaseDocsHandler } from "../../redux/action/getReleaseDocs";
import {
  createOrUpdateReleaseDocAction,
  createOrUpdateReleaseDocHandler,
} from "../../redux/action/createOrUpdateReleaseDoc";
import { ThemeContext } from "../../common/themeContext";
import Loader from "../Loder/loader";
import { useCommonMessage } from "../../common/CommonMessage";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";

const ReleaseDocuments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [switchStates, setSwitchStates] = useState({});
  const [documentData, setDocumentData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 100,
    showSizeChanger: true,
    pageSizeOptions: [5, 10, 15, 20],
    className: "order-pagination",
    locale: { items_per_page: "" },
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  });

  const {
    hasReleaseDocumentViewOnly,
    hasPermission,
    isSuperAdmin,
    PERMISSIONS,
  } = useAdminPermissions();

  const showManageReleaseDoc =
    isSuperAdmin || hasPermission(PERMISSIONS.RELEASE_DOCUMENT_EDIT);
  const showViewReleaseDoc = hasReleaseDocumentViewOnly;

  // When preparing columns, add index value to each data object in documentData
  const dataWithIdx = documentData.map((item, idx) => ({ ...item, idx }));
  // Update handleSwitchToggle to work with idx
  const handleSwitchToggle = (record, checked) => {
    setSwitchStates((prev) => ({
      ...prev,
      [record.idx]: checked,
    }));
    // Compose payload for status update
    const payload = {
      id: record.id,
      fileName: record.documentName,
      fileUrl: record.fileUrl || "",
      fileHtml: record.fileHtml || "",
      brandId: brandId,
      status: checked ? "ACTIVE" : "INACTIVE",
    };
    dispatch(createOrUpdateReleaseDocHandler(payload));
  };

  const createOrUpdateReleaseDocSelector = useSelector(
    (state) => state?.createOrUpdateReleaseDoc
  );
  const messageApi = useCommonMessage();
  useEffect(() => {
    if (createOrUpdateReleaseDocSelector?.data?.data) {
      messageApi.open({
        type: "success",
        content: createOrUpdateReleaseDocSelector?.data?.message,
      });
      dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocReset());
    } else if (createOrUpdateReleaseDocSelector?.message) {
      messageApi.open({
        type: "error",
        content: createOrUpdateReleaseDocSelector?.message,
      });
      dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocReset());
    }
  }, [createOrUpdateReleaseDocSelector]);

  const columns = releaseDocumentsColumns(
    navigate,
    handleSwitchToggle,
    switchStates,
    {
      showManage: showManageReleaseDoc,
      showView: showViewReleaseDoc,
      isViewOnly: hasReleaseDocumentViewOnly,
    },
  );

  const { brandId } = useContext(ThemeContext);
  const getReleaseDocsSelector = useSelector((state) => state?.getReleaseDocs);

  const handleReleaseDocsData = (
    offSet = 1,
    limit = 10,
    searchString = searchValue
  ) => {
    window.scrollTo(0, 0);

    if ([1, 2].includes(brandId)) {
      const payload = { offSet, limit, brandId: brandId };
      if (searchString) payload.searchString = searchString;
      dispatch(getReleaseDocsHandler(payload));
    }
  };

  useEffect(() => {
    handleReleaseDocsData();
  }, [
    brandId,
    createOrUpdateReleaseDocSelector,
  ]);

  useEffect(() => {
    const releaseDocsList = getReleaseDocsSelector?.data?.data;
    if (releaseDocsList) {
      const releaseDocsData = releaseDocsList?.map(
        ({
          fileName,
          status,
          currentVersion,
          // fileType,
          id,
          fileUrl,
          fileHtml,
          modifiedAt,
        }) => ({
          documentName: fileName,
          status: status && status.toUpperCase() === "ACTIVE",
          // fileType: fileType,
          id: id,
          fileUrl: fileUrl,
          currentVersion: currentVersion,
          fileHtml: fileHtml,
          modifiedAt: modifiedAt,
        })
      );
      setDocumentData(releaseDocsData);
      const { totalElements, pageNumber, pageSize } =
        getReleaseDocsSelector?.data;
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: totalElements,
        current: pageNumber,
        pageSize: pageSize,
      }));
    }
  }, [getReleaseDocsSelector]);
  return (
    <>
      {getReleaseDocsSelector?.isLoading ||
      createOrUpdateReleaseDocSelector?.isLoading ? (
        <Loader loaderTransform="loaderTransform" />
      ) : (
        <>
          <div className="rightside">
            <div className="rightcontent">
              <CustomBreadcrumb
                items={[
                  { text: BreadCrum.HOME },
                  {
                    text: BreadCrum.RELEASE_DOCUMENTS,
                    active: true,
                  },
                ]}
              />

              <div className="table-padding mb-30">
                <div className="headtitle d-flex justify-content-between">
                  <p className="mb-0 heedprodct">
                    Release Documents Management
                  </p>
                  <div className="flex gap-3 justify-end align-center mx420">
                    <CommanSearchBox
                      value={searchValue}
                      setValue={setSearchValue}
                      getSearchValue={handleReleaseDocsData}
                      placeholder={"Search By Document Name"}
                    />
                    {showManageReleaseDoc && (
                      <Link
                        className="primarybtn h-fit"
                        to="/manage-release-document"
                      >
                        <div className="plus"></div>
                        Add
                      </Link>
                    )}
                  </div>
                </div>
                <hr className="m-0" />
                <div className="table-responsive overfloauto">
                  <CommonTable
                    handlePageChange={handleReleaseDocsData}
                    pagination={pagination}
                    columns={columns}
                    body={dataWithIdx}
                    className="table usertable w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ReleaseDocuments;
